import Input from './../Input';
import HtmlEditor from '../../App/HtmlEditor';

const inputTypes = {
	'text':'text', 
	'numeric':'number', 
	'date':'date', 
	'time':'time', 
	'timestamp':'datetime-local', 
	'uuid':'text',
	'jsonb':'text',
}

function Html( props ) {

	const c = props.c
	const data = props.data
	const setData = props.setData

	const onChange = ( event, editor ) => { 
		// ckEditor onChange event is called onInit !!!!!!
		if ( Object.keys( data ).length > 0 ) {
			//console.log( 'html onChange', data, editor.getData() )
			const d = { ...data }
			d[ c.column_name ] = editor.getData()
			setData( d ) 
		}
	}

	return (

		<HtmlEditor 
			id={ c.column_name } 
			attr={ c.column_name } 
			//setKeyVal={ props.setData } 
			onChange={ onChange }
			value={ data[ c.column_name ] || '' } 
		/>

	)
}

function Text( props ) {

	const c = props.c
	const data = props.data
	const setData = props.setData

	return (

		<textarea 
			width="100%"
			rows="8" 
			style={{ fontFamily:'monospace', fontSize:15, border:'none'  }}
			//onChange={ e => setData( e.target.value ) } 
			value={ data[ c.column_name ] || '' }
			onChange={ e => { 
				const d = { ...data }
				d[ c.column_name ] = e.target.value
				setData( d ) 
			} }
		/>

	)
}

export default function TypedInput( props ) {

	const c = props.c
	const data = props.data
	const setData = props.setData

	const displayText = [ 'content', 'information', 'location_start_address', 'location_end_address', 'day_schedule', 'headers' ]
	const commonProps = { c, data, setData }

	//console.log( 'TypedInput props', props )

	// code wysiwyg

	return <>

	{ displayText.includes( c.column_name ) 

	  ? <Html { ...commonProps } />			

	  : <Input 
			item={ c.column_name } 
			type={ inputTypes[ c.data_type ] } 
			data={ data } 
			setData={ setData } 
			style={{ margin:0, width:'100%', minWidth:480, fontWeight:400, fontSize:15, border:'none' }}
		/>

	}

	</>

}
